import { z } from 'zod';

export const MouldSolutionType = z.enum(['solid', 'laminar_a', 'laminar_b']);

export type MouldSolutionType = z.infer<typeof MouldSolutionType>;

export const MouldCandidatePieceSchema = z.object({
  id: z.number(),
  cad_object_id: z.number(),
  pull_direction_id: z.number(),
  candidate_of: MouldSolutionType,
  refined: z.boolean(),
  direction_xyz: z.array(z.number()),
  centre_xyz: z.array(z.number()),
  hsize_xyz: z.array(z.number()),
  face_count: z.number(),
  mesh_face_count: z.number(),
  faces_in_same_plane: z.boolean(),
  total_surface_area: z.number(),
  // Triangle indices into the CAD object's rendered PLY mesh.
  object_face_indices: z.array(z.number()),
});

export type MouldCandidatePiece = z.infer<typeof MouldCandidatePieceSchema>;

export const MouldSolutionSchema = z.object({
  id: z.number(),
  side: z.enum(['front', 'back', 'both']),
  // Number of moulds needed; 2 for a 1 piece solution moulded from both sides.
  count: z.number(),
  is_closed: z.boolean(),
  is_incomplete: z.boolean(),
  solution_of: MouldSolutionType,
  is_laminar_pair: z.boolean(),
  score: z.number(),
  pieces: z.array(MouldCandidatePieceSchema),
  refined_pieces: z.array(MouldCandidatePieceSchema),
});

export type MouldSolution = z.infer<typeof MouldSolutionSchema>;

export const MouldSolutionsResponseSchema = z.array(MouldSolutionSchema);
